export interface LightspeedSettings {
  lsvEmail: string;
  lsvToken: string;
  apiKey: string;
}

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let msg = `API error: ${response.status}`;
    try {
      const body = await response.json();
      msg = body?.error?.message || body?.ErrorMessage || msg;
    } catch { /* ignore */ }
    throw new Error(msg);
  }
  return response.json() as Promise<T>;
}

export async function getLightspeedSettings(): Promise<LightspeedSettings> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/LightspeedVoice/settings`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return handleResponse<LightspeedSettings>(response);
}

export async function saveLightspeedSettings(data: Partial<LightspeedSettings>): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/LightspeedVoice/settings`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      LsvEmail: data.lsvEmail ?? '',
      LsvToken: data.lsvToken ?? '',
      ApiKey:   data.apiKey   ?? '',
    }),
  });
  await handleResponse<unknown>(response);
}

export async function removeLightspeedSettings(): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_Auth_Url}/api/LightspeedVoice/settings`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  await handleResponse<unknown>(response);
}
